import { render } from "./OkModal.vue?vue&type=template&id=a27147c6"
import script from "./OkModal.vue?vue&type=script&lang=js"
export * from "./OkModal.vue?vue&type=script&lang=js"

import "./OkModal.vue?vue&type=style&index=0&id=a27147c6&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__